export class Usersetting {
    personId:string;
    personlanguage:string;
    created:Date;
    createdby:string;
}